module.exports = __webpack_public_path__ + "img/skootel_hub.e2290e0e.png";